export default __webpack_public_path__ + "static/media/distripollo.aefac178.jpeg";